import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function StockUsageExample({ designer, designPath, stockPaths }) {
    return (
        <div className="stock-example">
            <div className="stock-example__design">
                <img src={designPath} />
                <span className="stock-example__design__attribution attribution">
                    <FormattedMessage id="byline" values={{ designer }} />
                </span>
            </div>
            <div className="stock-example__body">
                <div className="stock-example__text">
                    <FormattedMessage id="stock_example_body" />:
                </div>
                {stockPaths.map(path => (
                    <img key={path} className="stock-example__stock" src={path} />
                ))}
            </div>
        </div>
    );
}

StockUsageExample.propTypes = {
    designer: PropTypes.string.isRequired,
    designPath: PropTypes.string.isRequired,
    stockPaths: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/StockUsageExample.js